import { Auth, Cache } from "aws-amplify";

export const AuthInterceptor = async config => {
  const jwt = Cache.getItem("jwt");
  if (jwt && jwt.token && new Date().getTime() < jwt.expiration) {
    config.headers.Authorization = jwt.token;
    return config;
  }

  return Auth.currentSession()
    .then(session => {
      const token = session.getAccessToken().getJwtToken();
      config.headers.Authorization = token;
      Cache.setItem("jwt", {
        token,
        expiration: session.getAccessToken().getExpiration() * 1000
      });
      return config;
    })
    .catch(() => config);
};



// WEBPACK FOOTER //
// ./src/services/middleware/AuthInteceptor.ts